import bannerSlider from './components/banner-slider/banner-slider.vue';
import messages from './home-euroregio-translations';
import * as $ from 'jquery';

export default {
    name: 'instamapHome',
    i18n: {
        messages,
    },
    components: {
        bannerSlider,
    },
    data: () => {
        return {
            
        };
    },
    props: {
        selectedLang: { type: String },
        hasBreadcrumbs: { type: Boolean },
    },
    methods: {

    },
    mounted() {
        $('.menu-main').hide();
    },
    destroyed(){
        $('.menu-main').show();
    }
};



// WEBPACK FOOTER //
// ./src/home-euroregio/home-euroregio.js